// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yj3M","content":"styles_content__3MdI7","row":"styles_row__3S8Vt","footer":"styles_footer__3NImq","phraseLength":"styles_phraseLength__3h5P7"};